import { Box, Group, ScrollArea } from '@mantine/core'
import { useDebouncedValue, useHover, useMediaQuery } from '@mantine/hooks'
import { observer } from 'mobx-react-lite'
import type { PropsWithChildren } from 'react'

import { theme } from '@/configs/theme'
import * as classes from '@/styles/Navbar.css'

import { VersionButton } from './VersionButton'

type NavbarProps = PropsWithChildren

export const Navbar = observer(function Navbar(props: NavbarProps) {
  const { hovered, ref } = useHover()
  const [hoveredIn] = useDebouncedValue(hovered, 200)
  const [hoveredOut] = useDebouncedValue(hovered, 500)

  const mdBreakpoint = useMediaQuery(`(min-width: ${theme.breakpoints.md})`)

  const navbarExpanded = !mdBreakpoint || hoveredIn || hoveredOut

  return (
    <Box ref={ref} className={theme.cx(classes.navbar, navbarExpanded && classes.navbarExpanded)}>
      <ScrollArea className={classes.links} scrollbars="y">
        {props.children}
      </ScrollArea>

      <Group className={classes.footer}>{navbarExpanded && <VersionButton />}</Group>
    </Box>
  )
})

// Disabled: https://infinitered.slack.com/archives/C07MY1RQ63S/p1731088788357509
// useHotkeys([['mod+K', openSearchModal]])
// function openSearchModal() {
//   setProp('searchModalStatus', SearchModalStatus.Open)
// }
// <TextInput
//   value=""
//   readOnly
//   size="sm"
//   placeholder="Search"
//   variant="unstyled"
//   className={styles.searchInput}
//   leftSection={<IconSearch className={styles.searchLens} stroke={1.5} />}
//   rightSectionWidth={70}
//   rightSection={<Code className={styles.searchCode}>Ctrl + K</Code>}
//   onClick={openSearchModal}
// />
